import React from "react";

const Required = () => {
  return <span className="text-red-500">*</span>;
};

export default Required;
